export default "__VITE_ASSET__72Dmlx8u__"